export default {
	validations: {
		required: "Требуется значение.",
		undefined: "Требуется значение.",
		email: "Значение не является действительным адресом электронной почты",
		minLength: "Это поле должно содержать не менее ${min} символов",
		maxLength: "Максимально допустимая длина ${max}",
		minValue: "Минимальное допустимое значение: ${min}",
		maxValue: "Максимально допустимое значение: ${max}",
		numeric: "Значение должно быть числовым",
		ipAddress: "Значение не является действительным IP-адресом",
		sameAs: "Значение должно быть равно значению ${otherName}",
	}
}